import axios from "../lib/axios";
import { getCloudFunctionUrl } from "../utils/cloudFunctions";

export const savePreActivationFormRequest = async (defaultValues) => {
  const { data } = await axios({
    method: "post",
    url: `${getCloudFunctionUrl("savePreActivationForm")}/savePreActivationForm`,
    data: { defaultValues },
    headers: {
      "Content-Type": "application/json",
    },
  });
  return data;
};
